import React from 'react';
import cls from 'classnames';
import Bundle from '../../../models/Bundle';
import { BundleRowDelete } from './BundleRowDelete';
import styles from './bundle_table.module.scss';

type Props = {
  bundle: Bundle;
  onDelete: () => void;
  onSelect: () => void;
  selected?: boolean;
  monthlyPaymentTotal: number;
  shouldShowMonthlyPayment: boolean;
};

/**
 * Renders a single bundle.
 */
export const MultipleProductsBundleRow: React.FC<Props> = ({ bundle, selected, onSelect, onDelete, monthlyPaymentTotal, shouldShowMonthlyPayment }) => {
  return (
    <tr
      className={cls([selected ? styles.selected : null])}
      onClick={() => onSelect()}>
      <td>
        {[...bundle.energyItems].map(subscription => (<p key={subscription.id}>{subscription.name}</p>))}
      </td>
      <td style={{whiteSpace: "nowrap"}}>
        {shouldShowMonthlyPayment ? monthlyPaymentTotal + " kr" : null}
      </td>
      <td>
        <BundleRowDelete onDelete={onDelete} />
      </td>
    </tr>
  );
}